let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRVEf")).then(() => parcelRequire('bRRUe'));